import React from "react";
import { useAppLabel } from "../../../utils/useAppLabel";
import { RetryButton } from "./AdminUi";

const labels = {
  restaurants: "مطعم",
  branches: "فرع",
  applications: "تطبيق",
  months: "شهر",
  days: "يوم",
};

export default function HierarchyLevel({
  level,
  items,
  loading,
  error,
  onRetry,
  onSelect,
}) {
  const appLabel = useAppLabel();
  if (loading) return <div className="admin-empty">جاري تحميل المستوى…</div>;
  if (error)
    return (
      <div className="admin-empty admin-error">
        {error}{" "}
        <RetryButton onClick={onRetry} />
      </div>
    );
  if (!items.length)
    return (
      <div className="admin-empty">لا توجد نتائج مطابقة للفلاتر الحالية.</div>
    );
  return (
    <div className="doc-drill-list">
      {items.map((item) => (
        <button
          className="doc-drill-item"
          type="button"
          key={item.id}
          onClick={() => onSelect(item)}
        >
          <div className="doc-drill-main">
            <span className="doc-drill-arrow">‹</span>
            <span className="doc-drill-name">
              <span className="doc-level-label">{labels[level]}</span>
              {level === "applications"
                ? appLabel(item.app, item.name) || item.id
                : item.name || item.id}
            </span>
          </div>
          <div className="doc-drill-counts">
            <span className="doc-drill-count">{item.count} طلب</span>
            <span className="doc-drill-count done">{item.complete} مكتمل</span>
            <span className="doc-drill-count warn">
              {item.pending} قيد التوثيق
            </span>
            {!!item.rejected && (
              <span className="doc-drill-count rejected">
                {item.rejected} مرفوض
              </span>
            )}
          </div>
        </button>
      ))}
    </div>
  );
}
